"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Areas";

export default {
  getAllAreas() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllAreas`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  getOneAreaData(geofenceId) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetOneAreaData`, `?geoID=${geofenceId}`).then(
        ({ data }) => resolve(data)
      );
    });
  },
  saveArea(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveArea`, payload).result.then(({ data }) =>
        resolve(data)
      );
    });
  },
  deleteArea(geofenceId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/DeleteArea?geoID=${geofenceId}`).then(
        ({ data }) => resolve(data)
      );
    });
  }
};
